/**
 * Formata um número para moeda brasileira (R$ 1.234,56)
 * @param value O valor numérico a ser formatado
 * @returns String formatada no padrão brasileiro de moeda
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Formata um número para moeda brasileira sem o símbolo R$ (1.234,56)
 * @param value O valor numérico a ser formatado
 * @returns String formatada no padrão brasileiro sem símbolo
 */
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}; 